const calculateDimensions = (aspectRatio: number, containerWidth: number, containerHeight: number) => {
  const containerAspectRatio = containerWidth / containerHeight;

  return aspectRatio < containerAspectRatio ?
  {
    width: aspectRatio * containerHeight,
    height: containerHeight
  } :
  {
    width: containerWidth,
    height: containerWidth / aspectRatio
  };
};

export const AspectRatioHelper = {
  calculateDimensions
};
